import { defineStore } from 'pinia';
import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useAuthStore } from './useAuthStore';
import {
  subscribeToSearchResults,
  subscribeToLikedUnits,
  toggleInterest,
} from '@/services/SearchResultsService';

export const useSearchResultsStore = defineStore('searchResults', () => {
  const searchResults = ref(null);
  const interestedUnits = ref({});
  let unsubscribeFromSearchResults = null;
  let unsubscribeFromLikedUnits = null;

  const authStore = useAuthStore();
  const { uid } = storeToRefs(authStore);

  function initialize() {
    subscribeToLikedUnitsListener();
    subscribeToSearchResultsListener();
  }

  function subscribeToSearchResultsListener() {
    if (unsubscribeFromSearchResults) {
      unsubscribeFromSearchResults();
      unsubscribeFromSearchResults = null;
    }
    unsubscribeFromSearchResults = subscribeToSearchResults(
      uid.value,
      (results) => {
        searchResults.value = results;
      }
    );
  }

  function subscribeToLikedUnitsListener() {
    if (unsubscribeFromLikedUnits) {
      unsubscribeFromLikedUnits();
      unsubscribeFromLikedUnits = null;
    }
    unsubscribeFromLikedUnits = subscribeToLikedUnits(
      uid.value,
      (likes) => {
        interestedUnits.value = likes;
      }
    );
  }

  async function toggleUnitInterest(unit) {
    await toggleInterest(uid.value, unit, interestedUnits.value);
  }

  function dispose() {
    if (unsubscribeFromSearchResults) {
      unsubscribeFromSearchResults();
      unsubscribeFromSearchResults = null;
    }
    if (unsubscribeFromLikedUnits) {
      unsubscribeFromLikedUnits();
      unsubscribeFromLikedUnits = null;
    }
  }

  return {
    searchResults,
    interestedUnits,
    initialize,
    dispose,
    toggleUnitInterest,
  };
});
